"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVehicles = exports.setVehicles = exports.handleIncrementalResponse = exports.INCREMENTAL_RESPONSE_VEHICLES = exports.SET_VEHICLES = exports.FETCH_VEHICLES = exports.VEHICLES = void 0;
exports.VEHICLES = '[Vehicles]';
exports.FETCH_VEHICLES = `${exports.VEHICLES} FETCH`;
exports.SET_VEHICLES = `${exports.VEHICLES} SET`;
exports.INCREMENTAL_RESPONSE_VEHICLES = `${exports.VEHICLES} INCREMENTAL RESPONSE`;
const fetchVehiclesAction = ({ query, svd }) => {
    return {
        type: exports.FETCH_VEHICLES,
        payload: query + svd,
        meta: { feature: exports.VEHICLES },
    };
};
const handleIncrementalResponse = ({ response }) => {
    return {
        type: exports.INCREMENTAL_RESPONSE_VEHICLES,
        payload: response,
        meta: { feature: exports.VEHICLES },
    };
};
exports.handleIncrementalResponse = handleIncrementalResponse;
const setVehicles = ({ vehicles }) => ({
    type: exports.SET_VEHICLES,
    payload: vehicles,
    meta: { feature: exports.VEHICLES },
});
exports.setVehicles = setVehicles;
const fetchVehicles = ({ query }) => (dispatch, getState, svdModel) => svdModel.then((svd) => dispatch(fetchVehiclesAction({
    query,
    svd,
})));
exports.fetchVehicles = fetchVehicles;
//# sourceMappingURL=vehicles.js.map